// TODO: a11y: attributes, focus
// TODO: auto-select by hash in URL

import { getElements } from "@oddcamp/js-utils/src/selector";

const init = () => {
  const tgls = getElements(".js--tab-tgl");
  if (!tgls.length) return;

  tgls.forEach((tgl) => {
    tgl.addEventListener("click", (e) => {
      e.preventDefault();

      const id = tgl.getAttribute("href").replace("#", "");
      const [groupId /*, itemId*/] = id.split(":");

      const groupTgls = getElements(`.js--tab-tgl[href^="#${groupId}:"]`);
      groupTgls.forEach((groupTgl) => {
        const groupTglTab = groupTgl.closest(".js--tab");
        if (groupTglTab) groupTglTab.classList.remove("--active");
      });

      const idTgls = getElements(`.js--tab-tgl[href="#${id}"]`);
      idTgls.forEach((idTgl) => {
        const idTglTab = idTgl.closest(".js--tab");
        if (idTglTab) idTglTab.classList.add("--active");
      });

      const groupPanes = getElements(`.js--tab-pane[id^="${groupId}:"]`);
      groupPanes.forEach((groupPane) => {
        groupPane.classList.remove("--active");
      });

      const pane = document.getElementById(id);
      pane.classList.add("--active");
      pane.classList.add("--interacted");
    });
  });
};

if (typeof Turbolinks !== "undefined") {
  document.addEventListener("turbolinks:load", init);
} else {
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();
}
